import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
const miBlue = '#52b4db';
const miBlueDark = '#33648a';

let MiTheme = createTheme({
    palette: {
        primary: {
            main: miBlueDark,
            light: miBlue,
            contrastText: '#fff'
        },
        secondary: {
            main: '#ffb74d',
        },
        grey: {
            main: grey[300],
            dark: grey[400],
            light: '',
            contrastText: '#000000'
        },
        white: {
            main: '#fff',
        }
    },
    typography: {
        h3: {
            // fontSize: '3rem !important',
            color: miBlueDark,
            fontWeight: 'bold !important',
            // textAlign: 'left !important'
        },
        h4: {
            color: miBlueDark,
            fontWeight: 'bold !important',
        },
        h5: {
            color: miBlueDark,
            fontWeight: 'bold !important',
        },
        h6: {
            color: miBlueDark,
            fontWeight: 'bold !important',
        },
        subtitle2: {
            fontWeight: 'normal !important'
        }
    },
    props: {
        MuiTextField: {
            size: 'small',
            margin: 'dense',
        }
    },
    overrides: {
        MuiButton: {
            containedSecondary: {
                color: '#fff',
            },
        },
        MuiFab: {
            secondary: {
                color: '#fff',
            }
        }
    },
    components: {
        // Name of the component ⚛️
        MuiButton: {
            defaultProps: {
                size: 'medium',
            },
        },
        MuiFilledInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFormControl: {
            defaultProps: {
                // The default props to change
                size: "small",
                margin: 'dense'
            }
        },
        MuiFormHelperText: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputBase: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiListItem: {
            defaultProps: {
                dense: true,
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFab: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTextField: {
            defaultProps: {
                // The default props to change
                size: "small",
                margin: 'dense'
            }
        },
        MuiToolbar: {
            defaultProps: {
                variant: 'dense',
            },
        },
        MuiPickersTextField: {
            defaultProps: {
                // The default props to change
                size: "small",
                margin: 'dense'
            }
        },
        MuiDatePicker: {
            defaultProps: {
                slotProps: {
                    popper: {
                        popperOptions: {
                            modifiers: [
                                {
                                    name: 'flip',
                                    options: {
                                        altBoundary: false,
                                        fallbackPlacements: ['right', 'left'],
                                    },
                                },
                            ],
                        },
                    }
                }
            }
        }
        // MuiButton: {
        //     styleOverrides: {
        //         // Name of the slot
        //         root: ({ ownerState }) => ({
        //             ...(ownerState.variant === 'contained' &&
        //                 ownerState.color !== 'primary' && {
        //                     backgroundColor: grey[300],
        //                     color: '#000000',
        //                 }),
        //         }),
        //     },
        // },
        // MuiButton: {
        //     variants: [
        //         {
        //             props: (props) =>
        //                 props.variant === 'contained' && !props.color,
        //             style: {
        //                 backgroundColor: grey[300],
        //                 color: '#000000'
        //             }
        //         },
        //     ]
        // }
    }
});

MiTheme = responsiveFontSizes(MiTheme);

export default MiTheme;
